import PageWrapper from 'components/utils/PageWrapper';
import Portfolios from 'pages/Portfolios';

export const portfoliosRoutes = {
    path: '/portfolios',
    element: (
        <PageWrapper titleId="portfolios_title">
            <Portfolios />
        </PageWrapper>
    ),
};
